import { Box, Divider, Grid, Stack } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { jsonPathToValue } from '../../utils/json';
import { RootState } from '../../redux/store';
import { META_DATA_MODULES, META_DATA_SUB_MODULES } from '../../utils/constants';
import Link from '../../components/Link/Link';

import Typography from '../../components/Typography/Typography';
import Cases from './CasesList';
import Team from './TeamList';
import GridLabels from './GridLabels';
import { cases, team } from './VehicleVerticalTabs.mock';
import QuickGlanceLoader from './QuickGlanceLoader';
import useMetaData from '../../hooks/useMetaData';
import { generateRandomString } from '../../utils/string';
import image from '../../assets/images/image1.png';
import ExternalLink from '../../components/ExternalLink/ExternalLink';

const getTitle = (type: string, value: any) => {
  if (type === 'Date') {
    return value && moment(value).format('MMM D, YYYY');
  }
  if (type === 'Boolean') {
    if (value === true) {
      return 'Yes';
    }
    if (value === false) {
      return 'No';
    }
    return value;
  }
  return value;
};

// handling links
const handleLink = (name: string, replace: string, id?: string, url?: string) => {
  if (id) {
    return (
      <ExternalLink
        href={url?.replace(replace, id)}
        target="_blank"
        rel="noreferrer"
        style={{ fontSize: '14px', fontWeight: '500', color: '#456BD9' }}
      >
        {name}
      </ExternalLink>
    );
  }
  return (
    <Link to="/" onClick={(e) => e.preventDefault()} sx={{ fontSize: '14px', fontWeight: '500', color: '#456BD9' }}>
      {name}
    </Link>
  );
};

const QuickGlance = () => {
  const metaData = useMetaData(META_DATA_MODULES.v360Page, META_DATA_SUB_MODULES.vehicleDetailsTabs);
  const data = useSelector((state: RootState) => state.vehicle.data);

  const vehicleLabels = useMemo(
    () =>
      metaData?.selectedTab.rows?.[1]?.rows?.map((row: any) => {
        const value = jsonPathToValue(data, row.property);
        return {
          label: row.propertyName,
          title: getTitle(row.type, value),
          id: generateRandomString(10),
          isOptional: row.isOptional,
        };
      }) || [],
    [data, metaData?.selectedTab.rows]
  );

  if (!metaData || !data) return <QuickGlanceLoader />;

  const img = data?.configuration?.imageUrl || image;

  return (
    <Box sx={{ width: '100%' }}>
      {/* <img src={img} alt="car" style={{ width: '100%', display: 'block', objectFit: 'contain', minHeight: 200 }} /> */}
      <Grid container spacing={2} mt={1} pr={1.5} pl={1.5}>
        <GridLabels labels={vehicleLabels} />
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography size={12} weight={500} sx={{ textTransform: 'uppercase' }}>
              cases
            </Typography>
            <Link to="/" sx={{ fontSize: 12, fontWeight: 500, color: '#456BD9' }}>
              View all cases
            </Link>
          </Stack>
          <Cases cases={cases} />
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1.5}>
            <Typography size={12} weight={500} sx={{ textTransform: 'uppercase' }}>
              team
            </Typography>
            <Link to="/" sx={{ fontSize: 12, fontWeight: 500, color: '#456BD9' }}>
              View all members
            </Link>
          </Stack>
          <Team team={team} />
        </Grid>
        <Grid item xs={12} paddingTop={0}>
          <Box>
            <Typography size={12} weight={500} sx={{ textTransform: 'uppercase' }} textAlign="center" mb={1.5}>
              Reference Links
            </Typography>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-evenly"
              paddingBottom={2}
              divider={<Divider orientation="vertical" sx={{ height: '16px', width: '1px', borderColor: '#D9D9D9' }} />}
            >
              {handleLink(
                'Salesforce',
                'replaceSalesForce',
                data?.delivery?.Delivery_18_Char_ID__c,
                process.env.REACT_APP_SALESFORCE
              )}
              {handleLink('SAP', 'replaceSAP', data?.order?.sapOrderNumber, process.env.REACT_APP_SAP)}
              {handleLink('Lucid Garage', 'replaceVIN', data?.VIN, process.env.REACT_APP_LUCID_GARAGE)}
            </Stack>
          </Box>
        </Grid>
        {/* <Grid item xs={12}> */}
        {/*  <Box> */}
        {/*    <Typography size={12} weight={500} sx={{ textTransform: 'uppercase' }} textAlign="center" mt={3} mb={1}> */}
        {/*      Reference Links */}
        {/*    </Typography> */}
        {/*    <Stack */}
        {/*      direction="row" */}
        {/*      alignItems="center" */}
        {/*      justifyContent="space-evenly" */}
        {/*      divider={<Divider orientation="vertical" />} */}
        {/*    > */}
        {/*      <Link to="/">Salesforce</Link> */}
        {/*      <Link to="/">SAP</Link> */}
        {/*      <Link to="/">Lucid Garage</Link> */}
        {/*    </Stack> */}
        {/*  </Box> */}
        {/* </Grid> */}
      </Grid>
    </Box>
  );
};

export default QuickGlance;
